interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= totalPages; i += 1) {
    if (i === 1 || i === totalPages || Math.abs(i - page) <= 1) pages.push(i);
  }

  const items: Array<number | string> = [];
  pages.forEach((value, index) => {
    if (index > 0 && value - pages[index - 1] > 1) items.push(`gap-${value}`);
    items.push(value);
  });

  return (
    <nav className="flex flex-wrap items-center justify-center gap-2" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="flex h-9 cursor-pointer items-center justify-center gap-1 rounded-md border border-background-300/80 bg-background-50 px-3 text-sm text-foreground-700 transition hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-left-s-line" aria-hidden="true"></i>
        上一页
      </button>
      {items.map((item) =>
        typeof item === "number" ? (
          <button
            key={item}
            type="button"
            onClick={() => onChange(item)}
            aria-current={item === page ? "page" : undefined}
            className={`h-9 w-9 cursor-pointer rounded-md border text-sm transition ${
              item === page
                ? "border-primary-500 bg-primary-500 text-background-50"
                : "border-background-300/80 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
            }`}
          >
            {item}
          </button>
        ) : (
          <span key={item} className="px-1 text-sm text-foreground-400">
            …
          </span>
        ),
      )}
      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="flex h-9 cursor-pointer items-center justify-center gap-1 rounded-md border border-background-300/80 bg-background-50 px-3 text-sm text-foreground-700 transition hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        下一页
        <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
      </button>
    </nav>
  );
}